import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import AsyncStorage, { isWeb } from '../storage';
import SecureLS from 'secure-ls';

export interface PopupState {
  loading: boolean;
  status: any | null; // Keep this as a string if API returns just "LOCK" or "UNLOCK"
  error: string | null;
  updateSuccess: boolean;
  isWalletEnabled: boolean;
  isUserCanAddCard: boolean;
  NotRemindMeLater: any;
}

const initialPopupState: PopupState = {
  loading: false,
  status: null,
  isWalletEnabled: false,
  isUserCanAddCard: false,
  NotRemindMeLater: [],
  error: null,
  updateSuccess: false,
};

// Initialize storedUser asynchronously
let secureLS: SecureLS | null = null;
if (isWeb) {
  secureLS = new SecureLS({ encodingType: 'aes' });
}
let initialState: any = isWeb ? initialPopupState : null;
export const initializeStoredPopup = createAsyncThunk(
  'popup/initializeStoredPopup',
  async () => {
    initialState = isWeb ? null : await AsyncStorage.getItem('popup');
    return initialState ? JSON.parse(initialState) : initialPopupState;
  }
);

const popupSlice = createSlice({
  name: 'popup',
  initialState,
  reducers: {
    // Fetch Popup status
    fetchPopupStatusRequest(state, action) {
      state.loading = true;
      state.error = null;
    },
    fetchPopupStatusSuccess(state, action) {
      console.log("action",action)
      state.loading = false;
      state.status = action.payload.popUpStatus;
      state.error = null;
    },
    fetchPopupStatusFailure(state, action) {
      state.loading = false;
      // state.error = action.payload;
    },
    // Update Popup status
    updatePopupStatusRequest(state, action) {
      state.loading = true;
      state.updateSuccess = false;
      state.error = null;
    },
    updatePopupStatusSuccess(state, action) {
      state.loading = false;
      state.status = action.payload;
      state.updateSuccess = true;
      state.error = null;
    },
    updatePopupStatusFailure(state, action) {
      state.loading = false;
      state.updateSuccess = false;
      state.error = action.payload;
    },
    // Fetch Popup status
    fetchAccountStatusRequest(state, action) {
      state.loading = true;
      state.error = null;
    },
    fetchAccountStatusSuccess(state, action) {
      state.loading = false;
      state.isWalletEnabled =
        action.payload.shouldShowAppleWalletProvisioning &&
        action.payload.shouldShowGoogleWalletProvisioning;
      state.isUserCanAddCard =
        !action.payload.cardActivated &&
        action.payload.shouldShowAppleWalletProvisioning &&
        action.payload.shouldShowGoogleWalletProvisioning &&
        !state.status.showUnlockCardPopup;
      state.error = null;
    },
    fetchAccountStatusFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setPopupNotRemindMeLater(state, action) {
      state.NotRemindMeLater = [
        ...state.NotRemindMeLater,
        action.payload,
      ] as any;
      if (!isWeb) {
        AsyncStorage.setItem('popup', JSON.stringify(state));
      }
    },
    resetPopupSlice(state) {
      return initialPopupState; // Reset the slice to its initial state
    },
  },
  extraReducers: (builder) => {
    builder.addCase(initializeStoredPopup.fulfilled, (state, action) => {
      return action.payload;
    });
  },
});

export const {
  fetchPopupStatusRequest,
  fetchPopupStatusSuccess,
  fetchPopupStatusFailure,
  updatePopupStatusRequest,
  updatePopupStatusSuccess,
  updatePopupStatusFailure,
  fetchAccountStatusRequest,
  fetchAccountStatusSuccess,
  fetchAccountStatusFailure,
  setPopupNotRemindMeLater,
  resetPopupSlice,
} = popupSlice.actions;

export default popupSlice.reducer;
